exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__recipe-card-desc___2B_QU{display:flex;flex-flow:row;justify-content:center;color:rgba(0,0,0,.75)}.styles__recipe-card-desc___2B_QU a,.styles__recipe-card-desc___2B_QU div{display:flex;flex-flow:row;justify-content:center;align-items:center;padding:1rem;flex:1 1 auto;border:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.styles__recipe-card-desc___2B_QU a:hover,.styles__recipe-card-desc___2B_QU div:hover{background:#f8bbd0}.styles__recipe-card-desc___2B_QU .styles__title___FM5Yu{display:inline;text-align:center}.styles__recipe-card-desc___2B_QU a:hover{cursor:pointer}.styles__recipe-card-desc___2B_QU .styles__title___FM5Yu{font-size:1.25rem}.styles__recipe-card-desc___2B_QU span.styles__fa___1yGyj:not(.styles__fa-heart-o___34Et8){margin-right:.25rem}", ""]);

// exports
exports.locals = {
	"recipe-card-desc": "styles__recipe-card-desc___2B_QU",
	"title": "styles__title___FM5Yu",
	"fa": "styles__fa___1yGyj",
	"fa-heart-o": "styles__fa-heart-o___34Et8"
};